/* global $ */

class Header {
  constructor() {
    this.$container = $('.Header');
    this.$footerPosition = $('.Footer').offset().top;
    this.$menuItems = [];

    $('.MainMenu--header')
      .find('.MainMenuList__item-link')
      .each((i, e) => {
        this.$menuItems.push($(e));
      });
  }

  pageChange(namespace) {
    for (let i = 0; i < this.$menuItems.length; i++) {
      const itemNamespace = this.$menuItems[i].attr('data-namespace');
      if (itemNamespace !== undefined) {
        if (namespace.indexOf(itemNamespace) != -1) {
          this.$menuItems[i].addClass('current');
        } else {
          this.$menuItems[i].removeClass('current');
        }
      } else {
        this.$menuItems[i].removeClass('current');
      }
    }
  }

  // スクロールイベントが発生する度に呼ばれる関数
  update(scrollTop, windowHeight) {
    this.scrollTop = scrollTop;
    this.windowHeight = windowHeight;

    if (this.scrollTop > 0) {
      this.$container.addClass('Header--scrolled');

      if (this.scrollTop > this.$footerPosition - this.windowHeight) {
        this.$container.addClass('Header--hide');
      } else {
        this.$container.removeClass('Header--hide');
      }
    } else {
      this.$container.removeClass('Header--scrolled');
    }
  }
}

export default Header;
